














import { Component, Vue } from 'vue-property-decorator'
import { State, Action } from 'vuex-class'
import Item from './components/Item.vue'
@Component({
  components: {
    Item,
  },
})
export default class App extends Vue {
  @State('userInfo') userInfo
  @Action('fetchUserInfo') fetchUserInfo
  isIpad = false

  created() {
    if (!this.userInfo?.isLogin) {
      this.fetchUserInfo()
    }
  }

  mounted() {
    let ua = navigator.userAgent
    let h5Agents = ['iPad']
    for (let i = 0; i < h5Agents.length; i++) {
      if (ua.indexOf(h5Agents[i]) > -1) {
        this.isIpad = true
        break
      }
    }
    // console.log('%c this.isIpad ------> ', 'color:#0f0;', this.isIpad)
  }
}
